// components/Typography/index.jsx
import React from "react"
import VariantReader from "aldoo-ra/VariantReader"
import { twMerge } from "tailwind-merge"

const Typography = ({
  variant = "txt",
  styleOverrides,
  component,
  children,
  className = "",
  ...props
}) => {
  // Get the variant class from VariantReader
  let variantClass = VariantReader.useVariant({
    componentName: "Typography",
    variant,
    styleOverrides,
  })

  // Determine which HTML element to render based on variant or component prop
  const getComponent = () => {
    if (component) return component
  
    // Handle both regular and admin header tags
    const headerMatch = variant.match(/^(?:admin_)?h([1-4])/)
    if (headerMatch) {
      return `h${headerMatch[1]}`
    }
    
    // Group body variants
    if (variant.startsWith("body") || variant.startsWith("admin_body1")) {
      return "p"
    }
    
    // Group button and text variants
    if (variant.startsWith("btn") || variant.startsWith("admin_btn") || 
        variant.startsWith("txt") || variant.startsWith("admin_txt")) {
      return "span"
    }
    
    return "p"
  }

  const Component = getComponent()

  //convert empty object to empty string
  if (typeof variantClass === "object" && !Object.keys(variantClass).length) {
    variantClass = ""
  }

  const finalClassName = twMerge(variantClass, className)

  return (
    <Component className={finalClassName} {...props}>
      {children}
    </Component>
  )
}

export default Typography
